import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/autoprefixer': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M318.4 16l164.1 480h-77.5l-25.2-81.4h-119.5l-25.4 81.4h-77.5zM278.1 357.9h83.6l-40.9-130.4h-1.5zM640 405l-158.5 9.5-19.4-56.5 167.9 15.6zM177.9 358l-19.4 56.4-158.5-9.4 10-31.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/autoprefixer.js
// module id = 719
// module chunks = 0